export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const SET_AUTH_USER = "SET_AUTH_USER";
export const SET_LOGGED_USER = "SET_LOGGED_USER";
export const UPDATE_LOGGED_USER = "UPDATE_LOGGED_USER";
